import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { _ as _objectSpread2 } from '../../dist/objectSpread2-811c5212.esm.js';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { compose, nonEmpty, pick, mapObj, isEmpty } from '../../obj/dist/uswitch-ev-utils-obj.esm.js';
import '@babel/runtime/helpers/defineProperty';
import '@babel/runtime/helpers/typeof';
import '../../nil/dist/uswitch-ev-utils-nil.esm.js';

var _excluded = ["sys"],
  _excluded2 = ["includes", "rootEntity", "rootEntities"],
  _excluded3 = ["includes"];
var sys = function sys() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return s.sys || {};
};
var getFields = function getFields(_ref) {
  var _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? {} : _ref$fields;
  return fields;
};
var getAuthorName = function getAuthorName() {
  var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getFields(model).name || null;
};
var getAuthorUrl = function getAuthorUrl() {
  var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getFields(model).url || null;
};
var articleSchema = function articleSchema() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getFields(page).articleSchema || null;
};
var contentId = function contentId() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sys(entity).id;
};
var spaceId = function spaceId() {
  var _sys$space, _sys$space$sys;
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sys(entity).spaceId || ((_sys$space = sys(entity).space) === null || _sys$space === void 0 ? void 0 : (_sys$space$sys = _sys$space.sys) === null || _sys$space$sys === void 0 ? void 0 : _sys$space$sys.id);
};
var contentTypeId = function contentTypeId() {
  var _sys, _sys2, _sys2$contentType, _sys2$contentType$sys;
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ((_sys = sys(entity)) === null || _sys === void 0 ? void 0 : _sys.contentTypeId) || ((_sys2 = sys(entity)) === null || _sys2 === void 0 ? void 0 : (_sys2$contentType = _sys2.contentType) === null || _sys2$contentType === void 0 ? void 0 : (_sys2$contentType$sys = _sys2$contentType.sys) === null || _sys2$contentType$sys === void 0 ? void 0 : _sys2$contentType$sys.id);
};
var variantId = function variantId() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return entity.variant;
};
var layoutId = function layoutId() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return entity.layout;
};
var pageTitle = function pageTitle() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return getFields(page).title || '';
};
var contentfulEnv = process.env.CONTENTFUL_ENV || '';
var dataProps = function dataProps() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return nonEmpty({
    'data-content-type': contentTypeId(entity),
    'data-entity-id': contentId(entity),
    'data-space-id': spaceId(entity),
    'data-entity-name': entity.name || '',
    'data-entity-variant': variantId(entity) || '',
    'data-entity-layout': layoutId(entity) || '',
    'data-environment': contentfulEnv
  });
};
var findInclude = function findInclude(includes, id) {
  return Object.values(includes).find(function (it) {
    return contentTypeId(it) === id;
  });
};
var findIncludes = function findIncludes(includes, ids) {
  return Object.values(includes).filter(function (it) {
    return [].concat(ids).indexOf(contentTypeId(it)) > -1;
  });
};

/**
 * A contentful Entity
 * @typedef {Object} Entity
 * @property {Object} sys - The System info object of the entity
 * @property {string} sys.id - The id of entity
 */

/**
 * findEntities
 * Given a list of root entities, will return them from the contentful
 * includes state.
 *
 * @param {Object<string, Object>} includes - The contentful includes map
 * @param {Entity[]} entities - List of contentful entities to find
 * @
 */
var findEntities = function findEntities(includes, entities) {
  var entityIds = entities.map(contentId);
  return Object.values(pick(entityIds, includes));
};

// Selectors
var file = function file() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return s.file || {};
};
var sysId = function sysId() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sys(s).id || '';
};
var fileType = function fileType() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return file(entity).contentType || '';
};

// Modifiers
var assignContentTypeId = function assignContentTypeId(id) {
  return function (_ref2) {
    var sys = _ref2.sys,
      entity = _objectWithoutProperties(_ref2, _excluded);
    return _objectSpread2(_objectSpread2({}, entity), {}, {
      sys: _objectSpread2(_objectSpread2({}, sys), {}, {
        contentTypeId: id
      })
    });
  };
};

/* Simpify entities */
var simplifyEntitySys = function simplifyEntitySys(sys) {
  var _sys$space2, _sys$space2$sys, _sys$contentType, _sys$contentType$sys;
  return nonEmpty({
    id: sys === null || sys === void 0 ? void 0 : sys.id,
    spaceId: sys === null || sys === void 0 ? void 0 : (_sys$space2 = sys.space) === null || _sys$space2 === void 0 ? void 0 : (_sys$space2$sys = _sys$space2.sys) === null || _sys$space2$sys === void 0 ? void 0 : _sys$space2$sys.id,
    contentTypeId: sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : (_sys$contentType$sys = _sys$contentType.sys) === null || _sys$contentType$sys === void 0 ? void 0 : _sys$contentType$sys.id,
    total: sys === null || sys === void 0 ? void 0 : sys.total,
    createdAt: sys === null || sys === void 0 ? void 0 : sys.createdAt,
    updatedAt: sys === null || sys === void 0 ? void 0 : sys.updatedAt,
    trimmedContent: sys === null || sys === void 0 ? void 0 : sys.trimmedContent
  });
};
var simplifyEntrySys = function simplifyEntrySys(entry) {
  var _entry$sys, _entry$sys2;
  return entry !== null && entry !== void 0 && (_entry$sys = entry.sys) !== null && _entry$sys !== void 0 && _entry$sys.id ? {
    sys: {
      id: entry === null || entry === void 0 ? void 0 : (_entry$sys2 = entry.sys) === null || _entry$sys2 === void 0 ? void 0 : _entry$sys2.id
    }
  } : undefined;
};
var simplifyEntityFields = function simplifyEntityFields(fields) {
  return nonEmpty(!Array.isArray(fields === null || fields === void 0 ? void 0 : fields.entries) ? fields : _objectSpread2(_objectSpread2({}, fields), {}, {
    entries: fields.entries.map(simplifyEntrySys).filter(function (i) {
      return i;
    })
  }));
};
var simplifyEntity = function simplifyEntity(entity) {
  if (!entity || isEmpty(entity)) return {};
  var fields = entity.fields,
    sys = entity.sys;
  return nonEmpty({
    fields: simplifyEntityFields(fields),
    sys: simplifyEntitySys(sys)
  }, {});
};
var simplifyEntities = function simplifyEntities(_ref3) {
  var _ref3$includes = _ref3.includes,
    includes = _ref3$includes === void 0 ? {} : _ref3$includes,
    _ref3$rootEntity = _ref3.rootEntity,
    rootEntity = _ref3$rootEntity === void 0 ? {} : _ref3$rootEntity,
    _ref3$rootEntities = _ref3.rootEntities,
    rootEntities = _ref3$rootEntities === void 0 ? [] : _ref3$rootEntities,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    rootEntity: simplifyEntity(rootEntity),
    rootEntities: rootEntities.map(simplifyEntity),
    includes: mapObj(simplifyEntity, includes)
  });
};

/* Simplify Product dataset */
var simplifyProductDatasets = function simplifyProductDatasets(_ref4) {
  var _ref4$includes = _ref4.includes,
    includes = _ref4$includes === void 0 ? {} : _ref4$includes,
    rest = _objectWithoutProperties(_ref4, _excluded3);
  var productTables = Object.entries(includes).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      include = _ref6[1];
    return contentTypeId(include) === 'productTable';
  });
  var productDatasets = Object.fromEntries(productTables.map(function (_ref7) {
    var _dataset$fields, _dataset$fields2;
    var _ref8 = _slicedToArray(_ref7, 2),
      tableId = _ref8[0],
      table = _ref8[1];
    var dataset = includes[sysId(table.fields.dataset)];
    if (dataset !== null && dataset !== void 0 && (_dataset$fields = dataset.fields) !== null && _dataset$fields !== void 0 && _dataset$fields.query) return [tableId, table];
    var data = ((dataset === null || dataset === void 0 ? void 0 : (_dataset$fields2 = dataset.fields) === null || _dataset$fields2 === void 0 ? void 0 : _dataset$fields2.data) || []).filter(function (_ref9) {
      var id = _ref9.id;
      return !table.fields.filterIds ? true : table.fields.filterIds.includes(id);
    }).slice(0, table.fields.rowCount);
    return [tableId, _objectSpread2(_objectSpread2({}, table), {}, {
      fields: _objectSpread2(_objectSpread2({}, table.fields), {}, {
        filteredDataset: data
      })
    })];
  }));
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    includes: _objectSpread2(_objectSpread2({}, includes), productDatasets)
  });
};
var simplifyCtx = compose(simplifyProductDatasets, simplifyEntities);

export { articleSchema, assignContentTypeId, contentId, contentTypeId, dataProps, fileType, findEntities, findInclude, findIncludes, getAuthorName, getAuthorUrl, layoutId, pageTitle, simplifyCtx, spaceId, variantId };
